var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import id from "@irati/utils/id";
import authentication from "@irati/auth";
import AuthStream from "@irati/auth/streams/auth";
import UnauthedStream from "@irati/auth/streams/unauthed";
import ObserveWithPriority from "@irati/auth/helpers/auth/ObserveWithPriority";
import HeaderDesktop from "./desktop/HeaderDesktop";
import SecondaryNavDesktop from "./desktop/SecondaryNav";
import HeaderMobile from "./mobile/HeaderMobile";
import BrandLine from "./shared/BrandLine";
import MobileMenuOptions from "./mobile/MobileMenuOptions";
var idNamespace = "header";
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.stream = null;
        _this.state = {
            menuContext: undefined,
            isPanelOpen: false
        };
        _this.togglePanel = function (context) {
            var _a = _this.state, menuContext = _a.menuContext, isPanelOpen = _a.isPanelOpen;
            var isContextChanged = context !== menuContext;
            _this.setState({
                isPanelOpen: isContextChanged || !isPanelOpen,
                menuContext: context
            });
        };
        return _this;
    }
    Header.prototype.componentDidMount = function () {
        var _this = this;
        this.stream = new ObserveWithPriority({ streams: [AuthStream, UnauthedStream], key: "branding" }).subscribe(function (auth) {
            if (auth && auth.branding) {
                _this.setState({ auth: auth });
            }
            else {
                _this.setState({ auth: undefined });
            }
        });
    };
    Header.prototype.componentWillUnmount = function () {
        if (this.stream) {
            this.stream.unsubscribe();
        }
    };
    Header.prototype.render = function () {
        var _a = this.props, isMobile = _a.isMobile, location = _a.location;
        var _b = this.state, auth = _b.auth, menuContext = _b.menuContext, isPanelOpen = _b.isPanelOpen;
        if (!auth) {
            return null;
        }
        var color = auth.branding.primaryColour;
        var isLoggedIn = authentication.isLoggedIn();
        return (React.createElement(React.Fragment, null,
            !isMobile && React.createElement(HeaderDesktop, { id: id("desktop", idNamespace), auth: auth }),
            isMobile && React.createElement(HeaderMobile, { togglePanel: this.togglePanel, id: id("mobile", idNamespace), auth: auth }),
            isLoggedIn && React.createElement(BrandLine, { brandColor: color, isMobile: isMobile, id: id("brandLine", idNamespace) }),
            isMobile && (React.createElement(MobileMenuOptions, { isPanelOpen: isPanelOpen, menuContext: menuContext, togglePanel: this.togglePanel, id: id("mobileMenuOptions", idNamespace) })),
            !isMobile && React.createElement(SecondaryNavDesktop, { brandColor: color, pathname: location.pathname })));
    };
    return Header;
}(PureComponent));
var mapStateToProps = function (state) {
    return {
        isMobile: state.mq.lessThan.medium
    };
};
export default withRouter(connect(mapStateToProps)(Header));
